import RecordarContrasena from './RecordarContrasena';

export default RecordarContrasena;
